export default {
  "content": "<g clip-path=\"url(#prefix__clip0)\"><path fill=\"#3F4450\" d=\"M11.61 4.057a.4.4 0 01.015.56l-4.68 5.025c-.21.225-.505.35-.81.35a1.104 1.104 0 01-.805-.365L.855 4.637a.4.4 0 01.025-.56l.48-.445c.165-.15.42-.14.57.025l4.22 4.715 4.42-4.75c.15-.165.41-.17.57-.015l.47.45z\"/></g><defs><clipPath id=\"prefix__clip0\"><path fill=\"#fff\" d=\"M0 0h6.5v10.985H0z\" transform=\"rotate(-90 5.371 4.621)\"/></clipPath></defs>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "12",
    "height": "12",
    "fill": "none"
  }
};